import { useFormik } from "formik";
import useParks from "../../../hooks/api-calls/useParks";
import useHandleErrors from "../../../hooks/useHandleErrors";
import { toast } from "sonner";
import { useEffect } from "react";
import { ActionIcon, Button, Modal, Text } from "rizzui";
import { IoClose } from "react-icons/io5";
import CustomSelect from "../../../components/forms/CustomSelect";
import { Park } from "../../../type/entities/park-type";
import { ParkService } from "../../../services/park/parkService";
import useUsers from "../../../hooks/api-calls/useUsers";


interface AddUsersToParkModalProps {
    isOpen: boolean;
    onClose: () => void;
    refetch: () => void;
    park: Park | null;
    parkHasUsers: any;
}


const AddUsersToParkModal: React.FC<AddUsersToParkModalProps> = ({ isOpen, onClose, refetch, park, parkHasUsers }) => {

    // STATES

    const service = new ParkService();
    
    // HOOKS

    const { handleErrors } = useHandleErrors();
    const { getUsersList } = useUsers({role: 'Coordinador'});

    // FORMIK

    const formik = useFormik({
        initialValues: {
            id : '',
            users: [],
        },
        validateOnBlur: false,
        onSubmit: values => {
            handleCreate(values)
        },
    })

    // FUNCTIONS

    //--------------------------------------------------------------------------------------------------------------
    /**
     * @ES AÑADIR PARQUES AL CLIENTE
     * @EN ADD PARKS TO CLIENT
     * 
     * @param values
     * @returns
     */
    //--------------------------------------------------------------------------------------------------------------
    const handleCreate = async (values: any) => {
        try {
            const response = (await (service.addUsersToPark( values.id, values.users ))).getResponseData();
            if(response.success) {
                refetch();
                onClose();
                toast.success('Coordinador añadido al parque con éxito');
            }
            else {
                toast.error('Error al añadir coordinador al parque');
            }
        } catch (error) {
            handleErrors(error);
        }
    }
    //--------------------------------------------------------------------------------------------------------------


    // USE EFFECT

    useEffect(() => {
        if(park) {
            formik.setFieldValue('id', park.id);
            formik.setFieldValue('users', parkHasUsers? parkHasUsers.map((users: any) => users.user): []);
        }
    }
    , [park]);


    // RENDER

    return (
        <Modal 
            isOpen={isOpen}
            onClose={onClose}
            size='sm'
            overlayClassName='backdrop-blur'
            containerClassName='!max-w-xl !shadow-xl'
            className='z-[9999] [&_.pointer-events-none]:overflow-visible'
        >
            <div className="m-auto px-7 pt-6 pb-4">
                <div className="mb-7 flex items-center- justify-between">
                    <Text className="text-xl"> Administrar coordinadores del parque {park?.name} </Text>
                    <ActionIcon size="sm" variant="text" onClick={onClose}>
                        <IoClose className='h-auto w-6' strokeWidth={1.8} />
                    </ActionIcon>
                </div>

                <CustomSelect
                    id="users"
                    label="Coordinadores"
                    placeholder="Selecciona los Coordinadores"
                    isMulti
                    options={getUsersList()}
                    isClearable
                    isSearchable
                    onChange={(selectedOptions: any) => {
                        const selectedValues = selectedOptions.map((option: any) => option.value);
                        formik.setFieldValue('users', selectedValues);
                    }}
                    value={formik.values.users.map((user: any) => {
                        const selectedUser = getUsersList().find((option: any) => option.value === user);
                        return selectedUser ? selectedUser : { value: user.id, label: user.name + ' ' + user.lastName };
                    })}
                    className="mb-4"
                />
            </div>

            <div className='flex justify-center p-7'>
                <Button
                    disabled={false}
                    onClick={() => formik.handleSubmit()}
                    color='primary'
                >
                    Añadir
                </Button>
            </div>  

        </Modal>

    )


}

export default AddUsersToParkModal;